import {useEnvironmentStore} from '@/env/useEnvironmentStore';

export const createNewRelic = () => {
  const environmentStore = useEnvironmentStore();

  const getNewRelicConfig = () => {
    // Use the same structure as window.globalConfig?.newRelic
    const newRelic = environmentStore.environment?.newRelic;
    return {
      accountId: newRelic?.accountId,
      applicationId: newRelic?.applicationId,
      licenseKey: newRelic?.licenseKey,
      beacon: newRelic?.beacon,
      releaseName: newRelic?.releaseName,
      appUrl: newRelic?.appUrl,
    };
  };

  const injectNewRelic = () => {
    const config = getNewRelicConfig();
    if (!config.accountId || !config.applicationId || !config.licenseKey || !config.beacon) {
      // Do not inject if config is incomplete
      return;
    }

    // Inject global config script (matching previous config)
    const configScript = document.createElement('script');
    configScript.type = 'text/javascript';
    configScript.text = `
      window.NREUM = window.NREUM || {};
      NREUM.init = {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["${config.beacon}"] }
      };
      NREUM.loader_config = {
        accountID: "${config?.accountId}",
        trustKey: "${config?.accountId}",
        agentID: "${config?.applicationId}",
        licenseKey: "${config?.licenseKey}",
        applicationID: "${config?.applicationId}",
      };
      NREUM.info = {
        beacon: "${config?.beacon}",
        errorBeacon: "${config?.beacon}",
        licenseKey: "${config?.licenseKey}",
        applicationID: "${config?.applicationId}",
        sa: 1
      };
    `;
    document.head.appendChild(configScript);

    // Inject New Relic loader script
    const script = document.createElement('script');
    script.src = '/staticv2/newrelic.js';
    document.head.appendChild(script);
  };

  return {
    install: () => {
      if (typeof window === 'undefined') return;
      injectNewRelic();
    },
  };
};
